import { useContextSelector } from 'use-context-selector'

import { TurnListContext } from '../context/TurnListProvider'

export const useSalesAssociates = () => {
  const salesAssociates = useContextSelector(
    TurnListContext,
    (turnList) => turnList.salesAssociates
  )

  return {
    salesAssociates,
  }
}
